export const SORT_ORDER = 'LocalSettings:Conversations:hsSortOrder';